import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Scene3D from '../3d/Scene3D';
import WhatsAppButton from '../ui/WhatsAppButton';
import PropTypes from 'prop-types';

const Layout = ({ children }) => {
    const location = useLocation();
    
    // Hide navbar and footer on specific legal/privacy policy pages
    const isIsolatedPage = ['/snapsort/privacy-policy', '/yukta-policy'].includes(location.pathname);

    return (
        <div className="flex flex-col min-h-screen bg-background text-slate-900 selection:bg-primary selection:text-white relative">
            {/* Global 3D particle field background — sits behind everything */}
            {!isIsolatedPage && <Scene3D />}
            
            {!isIsolatedPage && <Navbar />}
            
            <main className="grow relative z-10">
                {children}
            </main>
            
            {!isIsolatedPage && <Footer />}
            {!isIsolatedPage && <WhatsAppButton />}
        </div>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
